import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import {
  monitorConfig,
  testConfig
} from '../../docs-routes'
import { useModule } from '@eggplant/routing'

const TestConfigs = () => {
  const [isMonitorFlag] = useModule()

  const typeBasedParagraphText = !isMonitorFlag
    ? 'Test Configs are combinations of test cases and exploratory tests grouped in specific sequences to run against systems under test (SUTs).'
    : 'Monitor Configs are test cases tests grouped in specific sequences to run against systems under test (SUTs) regularly, which will provide a series of test results against time that you can check in monitor results and dashboard page.'

  const docsPath = !isMonitorFlag
    ? testConfig
    : monitorConfig

  return (
    <Paragraph>
      <Color variant='theme-description-text'>
        {typeBasedParagraphText}
      </Color>
      <DocusaurusFooter path={docsPath} />
    </Paragraph>
  )
}

export default TestConfigs
